import {
    Component,
    OnInit,
    Input,
    Output,
    ViewChild,
    ContentChildren,
    QueryList,
    ViewContainerRef,
    EventEmitter,
    ElementRef,
} from "@angular/core";
import { BaseDataSource } from "../../../../utils/datasources/shared/_base.datasource";
import { WtfAnimations } from "../../../../utils/others/core/animations";
import {} from "reflect-metadata";
import { TableAction } from "../../../../utils/types/shared/table-action";
import { TemplateLoaderDirective } from "../../../../utils/directives/shared/template-loader.directive";
import { DataType } from "../../../../utils/enums/shared/enums";
import { PropertyChange } from "../../../../utils/types/shared/property-change";
import { MatSort } from "@angular/material/sort";
import { Subscription } from "rxjs";

@Component({
    selector: "wtf-table",
    templateUrl: "./table.component.html",
    styleUrls: ["./table.component.scss"],
    animations: WtfAnimations,
})
export class TableComponent implements OnInit {
    @Input() dataSource: BaseDataSource<any>;
    @Input() hidePaginator: boolean;
    @Input() actions: Array<TableAction>;
    @Input() showAddButton: Boolean;
    @Output() booleanChangeEvent = new EventEmitter<PropertyChange>();
    @Output() rowClick = new EventEmitter<any>();
    @Output() rowDoubleClick = new EventEmitter<any>();
    @Output() addButtonClickHandler = new EventEmitter<any>();
    @Output() initialized = new EventEmitter<any>();
    @Output() propertyChanged = new EventEmitter<PropertyChange>();

    fields: Array<string>;
    columnsToShow: Array<string>;
    captions: any = {};
    columnTypes: any = {};
    selectedRecord: any;
    tableMakerSubscription: Subscription;
    emptyTable: Boolean = false;

    @ViewChild(MatSort) sort: MatSort;

    ngOnInit() {
        if (!this.dataSource) {
            return;
        }

        this.tableMakerSubscription = this.dataSource
            .connect()
            .subscribe((res) => {
                this.emptyTable = false;
                if (res && res.length === 0) {
                    this.emptyTable = true;
                }

                this.getTableInfo(res);
            });
    }

    registerSorting() {
        setTimeout(() => {
            if (this.sort) {
                this.sort.sortChange.subscribe((res) => {
                    if (this.dataSource) {
                        this.dataSource.sortData(res.active, res.direction);
                    }
                });
            }
        }, 2000);
    }

    getTableInfo(data: any) {
        if (!data || this.fields) {
            return;
        }

        const record = data[0];
        this.mapColumns(record);
    }

    mapColumns(record: any) {
        if (!record) {
            return;
        }

        const localFields = new Array<string>();
        this.columnsToShow = new Array<string>();
        const columns = record["columns"];

        if (!columns) {
            return;
        }

        Object.keys(columns).forEach((prop) => {
            localFields.push(prop);
            this.columnsToShow.push(prop);
            this.captions[prop] = columns[prop];
        });

        const types = record["types"];
        Object.keys(types).forEach((prop) => {
            this.columnTypes[prop] = types[prop];
        });

        this.fields = localFields;
        this.columnsToShow.push("buttons");

        if (this.tableMakerSubscription !== undefined) {
            this.tableMakerSubscription.unsubscribe();
        }

        this.registerSorting();
        this.initialized.emit();
    }

    performAction(action: TableAction, entity: any) {
        if (!action) {
            return;
        }

        action.callback(entity);
    }

    changeBoolean(row, field, source) {
        this.booleanChangeEvent.next(new PropertyChange(field, row, source));
        // this.processValueChanged(row, field, source);
    }

    performRowClick(entity) {
        this.selectedRecord = entity;
        this.rowClick.next(entity);
    }

    performRowDoubleClick(entity) {
        this.selectedRecord = entity;
        this.rowDoubleClick.next(entity);
    }

    performPagination(data: any) {
        if (!this.dataSource) {
            return;
        }
        this.dataSource.filter.offset = data.pageIndex * data.pageSize;
        this.dataSource.filter.limit = data.pageSize;
        this.dataSource.getList();
    }

    addNewClicked() {
        this.addButtonClickHandler.emit();
    }

    processValueChanged(row, field, source) {
        if (source && source.target) {
            row[field] =
                source.target.type === "number"
                    ? +source.target.value
                    : source.target.value;
            this.propertyChanged.emit(new PropertyChange(field, row, source));
        }
    }

    ConvertBoolean(value) {
        return Boolean(value);
    }
}
